import * as CouponRateActions from 'actions/CouponRate';
import * as MakeBetActions from 'actions/MakeBet';

const initialState = false;

export default function currentBetTypeSelectedReducer(state, action) {
    switch (action.type) {
        case CouponRateActions.SET_COUPON_BET_TYPE:
            return true;

        case CouponRateActions.REMOVE_COUPON_RATES:
            return initialState;

        case MakeBetActions.SUCCESS_MAKE_BET:
            const createdBets = action.data;
            let rateBlockNum = 0;

            for (let offset = 0; offset < createdBets.length; offset++) {
                const createdBet = createdBets[offset];

                if (createdBet.error !== undefined && createdBet.error) {
                    if (createdBet.error === -3 && createdBet.factors !== undefined) {
                        rateBlockNum++;
                    }
                    if(createdBet.error === -18){
                        rateBlockNum++;
                    }
                }
            }

            return (rateBlockNum === 0) ? initialState : true;

        case MakeBetActions.FAILURE_MAKE_BET:
            return initialState;
    }

    return state;
}


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/currentBetTypeSelectedReducer.js